// Navigation
const navToggle = document.querySelector('.navigation')

const openNavFull = () => {
    document.body.classList.add('nav-is-open')

    document.addEventListener('keyup', event => {
        if (event.key === 'Escape') closenavFull()
    })
}

const closeNavFull = () => {
    document.body.classList.remove('nav-is-open')
}

//Hamburger Menu
if (navToggle) {
    navToggle.addEventListener('click', () => {
        if (document.body.classList.contains('nav-is-open')) {
            closeNavFull()
            return
        }
        openNavFull()
    })
}
